  //Creates an event for the user on intercom.
  export const trackIntercomEvent = (eventName, eventMetadata) =>{
    window.Intercom('trackEvent', eventName, {...eventMetadata});
  }